export default "__VITE_ASSET__PsSeewYK__"